// extracted by mini-css-extract-plugin
module.exports = {"hideSolution":"hideSolution__13lRJ","hideIcon":"hideIcon__2uzxJ"};